import {tns} from 'tiny-slider/src/tiny-slider.module';
import Bowser from 'bowser';

export const initPopularPagesSlider = () => {
  const browser =  Bowser.getParser(window.navigator.userAgent);
  const isSafari = browser.isBrowser('safari');


  for (const slider of document.getElementsByClassName('popular-pages__slider')) {
    const sliderContainer = slider.getElementsByClassName('popular-pages__slide-container')[0];
    const autoplay = document.getElementById('auto-scroll-flag') !== null;
    if(isSafari) {
      Array.from(slider.getElementsByClassName('popular-pages__page__inner')).forEach(p => p.classList.add('--safari'));
    }
    const tinyslider = tns({
      container: sliderContainer,
      items: 1,
      autoplay,
      autoplayTimeout: 4000,
      autoplayButtonOutput: false,
      autoplayHoverPause: true,
      controls: true,
      nav: false,
      gutter: 30,
      lazyload: true,

      responsive: {
        760: {
          items: 2,
        },
        960: {
          items: 3,
        },
        1440: {
          items: 4
        }
      },
      controlsContainer: slider.getElementsByClassName('popular-pages__controls')[0]
    });
    slider.style.height = 'auto';
  }
};
